import { authRoles } from 'app/auth';
import EventTable from './table/EventTable';
import EventEditForm from './editform/EventEditForm';

export default [
	{
		path: '/event/edit/:id',
		component: EventEditForm,
		auth: authRoles.event
	},

	{
		path: '/event/:sessionNameParam?',
		component: EventTable,
		auth: authRoles.event
	}
];
